/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LocationRateDto } from './locationRateDto';


export interface LocationRateDtoPagedResultDto { 
    items?: Array<LocationRateDto> | null;
    totalCount?: number;
}

